import React from 'react';
import { bool, element, oneOfType, func, } from 'prop-types';
import { Route, Redirect, } from 'react-router-dom';

const PrivateRoute = ({ component: Component, isAuth, ...rest }) => (
  <Route
    { ...rest }
    render={ (props) => {
      if (isAuth) {
        return <Component { ...props } />;
      }
      return (<Redirect
        to={ {
          /* eslint-disable */
          pathname: `/${props.match.params.projectId}/login`,
          state: { from: props.location }
          /* eslint-enable */
        } }
      />);
    } }
  />
);

PrivateRoute.propTypes = {
  component: oneOfType([element, func]).isRequired,
  isAuth: bool,
};
PrivateRoute.defaultProps = {
  isAuth: false,
};

export default PrivateRoute;



// WEBPACK FOOTER //
// ./src/router/PrivateRoute.js